import { Game } from '../types';
import { api } from '../api-client.config';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

const updateGame = (game: Game) => api.put(`/game/${game.id}`, game);

export const useUpdateGameMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['update-game'],
    mutationFn: updateGame,
    onSuccess: () => {
      toast.success('Game updated successfully');

      queryClient.invalidateQueries({
        queryKey: ['games'],
      });
    },
  });
};
